import { Component, OnInit } from '@angular/core';
import { AuthenticationService, ProfileService, AlertService,CompanyService} from '../_services/index';
import {Router, ActivatedRoute} from "@angular/router"
import { AsapScheduler } from 'rxjs/internal/scheduler/AsapScheduler';
// import { stringify } from 'querystring';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent implements OnInit {
  private authorized:any;
  public param:any;
  public business:any;
  public a:any;
  constructor(
    public profileService: ProfileService,
    public companyService:CompanyService,
    private router: Router,
    public as: AuthenticationService,
    private route: ActivatedRoute,
  ) { 
    this.authorized = this.as.checkAuthentication();
      if(!this.authorized.authorized){
          this.router.navigate(['/login'])
      }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.a=JSON.stringify(params);
    });
    this.param = {
      page:JSON.parse(this.a).page?JSON.parse(this.a).page:1,
      offset:JSON.parse(this.a).offset?JSON.parse(this.a).offset:100,
      orderby:"[['name','"+(JSON.parse(this.a).name?JSON.parse(this.a).name:'ASC').toString()+"']]",
      name:JSON.parse(this.a).name?JSON.parse(this.a).name:'ASC',
    }
    this.getCompany(this.param);
  }
  changeFilter(){
    console.log(this.param)
    this.param.orderby = "[['name','"+this.param.name.toString()+"']]",
    this.getCompany(this.param);
  }
  url(path: any){
    this.router.navigate([path]);
  }
  getCompany(data: any){
    this.companyService.getBussiness(data).subscribe(response => {
        this.business = response; 
    }, error => {
    })
  }
}
